import {
  SUBSCRIPTIONS_ALL,
  SUBSCRIPTIONS_ALL_SUCCESS,
  SUBSCRIPTIONS_CREATE,
  SUBSCRIPTIONS_CREATE_SUCCESS,
  SUBSCRIPTIONS_DELETE,
  SUBSCRIPTIONS_DELETE_SUCCESS,
  SUBSCRIPTIONS_GET,
  SUBSCRIPTIONS_GET_SUCCESS,
  SUBSCRIPTIONS_UPDATE,
  SUBSCRIPTIONS_UPDATE_SUCCESS,
} from '../constants/Subscriptions';

export const getAllSubscriptions = () => ({
  type: SUBSCRIPTIONS_ALL,
});

export const getAllSubscriptionsSuccess = (subscriptions) => ({
  type: SUBSCRIPTIONS_ALL_SUCCESS,
  subscriptions,
});

export const getSubscription = () => ({
  type: SUBSCRIPTIONS_GET,
});

export const getSubscriptionSuccess = (subscription) => ({
  type: SUBSCRIPTIONS_GET_SUCCESS,
  subscription,
});

export const createSubscription = (data) => ({
  type: SUBSCRIPTIONS_CREATE,
  data,
});

export const createSubscriptionSuccess = (subscription) => ({
  type: SUBSCRIPTIONS_CREATE_SUCCESS,
  subscription,
});

export const updateSubscription = (id, data) => ({
  type: SUBSCRIPTIONS_UPDATE,
  id,
  data,
});

export const updateSubscriptionSuccess = (subscription) => ({
  type: SUBSCRIPTIONS_UPDATE_SUCCESS,
  subscription,
});

export const deleteSubscription = (id, history) => ({
  type: SUBSCRIPTIONS_DELETE,
  id,
  history,
});

export const deleteSubscriptionSuccess = (subscription) => ({
  type: SUBSCRIPTIONS_DELETE_SUCCESS,
  subscription,
});